var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inputContent)?_c('div',{staticClass:"msg-auto-complete"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.onClickMsg(item)}}},[_c('span',{staticClass:"text"},[_c('i',{staticClass:"icon-q"}),_vm._v(_vm._s(item.question))])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }